import { Outlet, createRootRoute, useNavigate, useRouterState } from '@tanstack/react-router';
import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { fetchMe } from '../lib/auth';
import { Nav } from '../components/nav';

export const Route = createRootRoute({ component: RootLayout });

function RootLayout() {
  const { data, isLoading } = useQuery({ queryKey: ['me'], queryFn: fetchMe });
  const { location } = useRouterState();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading && !data && location.pathname !== '/login') {
      navigate({ to: '/login' });
    }
  }, [data, isLoading, location.pathname, navigate]);

  const showNav = !!data && location.pathname !== '/login';

  return (
    <div className="min-h-screen bg-bg-base text-neutral-100">
      {showNav && <Nav bankedEnergy={data?.bankedEnergy ?? 0} />}
      <Outlet />
    </div>
  );
}
